import { render, staticRenderFns } from "./ParamTipoEmbarcacao.vue?vue&type=template&id=2d3a2a05"
import script from "./ParamTipoEmbarcacao.vue?vue&type=script&lang=js"
export * from "./ParamTipoEmbarcacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports